// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"0917509a","280":"e4e70d32","944":"0917509a"}[chunkId] + ".chunk.css";
};